const getBaseURL = (initialURL: string, serviceName: string) => {
  const v2Services = process.env.V2_SERVICES?.split(',') || [];
  if (v2Services.includes(serviceName)) return initialURL;
  const url = initialURL.replace('/v2', '');
  return url;
};
export default getBaseURL;
